import API from 'src/api'
import { http } from '../boot/axios'

export default {
    GRAPHQL_URL: API.GRAPHQL_URL,
  getAdminPermissions () {
    return new Promise((resolve, reject) => {
      http.get(API.GRAPHQL_URL + 'permissions')
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  }
}
